import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import utc from 'dayjs/plugin/utc'
import relativeTime from 'dayjs/plugin/relativeTime'
import timezone from 'dayjs/plugin/timezone'
import advancedFormat from 'dayjs/plugin/advancedFormat'
import isBetween from 'dayjs/plugin/isBetween'
import customParseFormat from 'dayjs/plugin/customParseFormat'

import 'dayjs/locale/en'
import 'dayjs/locale/ja'
import 'dayjs/locale/zh'
import 'dayjs/locale/vi'
import 'dayjs/locale/es'
import 'dayjs/locale/pt'

dayjs.extend(duration)
dayjs.extend(utc)
dayjs.extend(relativeTime)
dayjs.extend(timezone)
dayjs.extend(advancedFormat)
dayjs.extend(isBetween)
dayjs.extend(customParseFormat)

dayjs.locale(process.env.DEFAULT_LOCALE)
dayjs.tz.setDefault(process.env.DEFAULT_ZONE)

export function useDayjs() {
  return dayjs
}

export default dayjs
